import { Component, Input, OnInit } from '@angular/core';
import { Solution } from 'src/app/core/models/solutions-events';

@Component({
  selector: 'solution-card',
  templateUrl: './solution-card.component.html',
  styleUrls: ['./solution-card.component.scss'],
  standalone: false,
})
export class SolutionCardComponent implements OnInit {
  @Input() solution: Solution;
  defaultButtonText: string = 'Learn More';

  constructor() {}

  ngOnInit(): void {}

  onLearnMore() {
    window.open(this.solution.linkUrl, '_blank');
  }

  renderButtonText(): string {
    if (this.solution?.linkDescription) {
      const maxLenghtLinkDescription = 20;
      const shortDescription =
        this.solution.linkDescription.length > maxLenghtLinkDescription
          ? this.solution.linkDescription.substring(0, maxLenghtLinkDescription) + '...'
          : this.solution.linkDescription;
      return shortDescription;
    }
    return this.defaultButtonText;
  }
}
